import { CommonCancellationsCrumbs } from './breadcrumb';

export const CancellationNonResidentSearchCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Persona - Cancellazione Non residente',
    path: '/cancellazioni/non-residenti',
  },
];

export const CancellationNonResidentFormCrumbs = [
  ...CancellationNonResidentSearchCrumbs,
  {
    name: 'Cancellazione Non residente',
    path: '/cancellazioni/non-residenti/operazione',
  },
];
